import React from "react";
import ModalBox from "./Modalbox";
import axios from "axios";
import { api } from "./api/client";
import MUIDataTable from "mui-datatables";
import { createTheme,ThemeProvider,adaptV4Theme } from '@mui/material/styles';
import {utils, write} from "xlsx";
import { saveAs } from 'file-saver'
import ExpandableRowMachinesTable from "./ExpandableRowMachinesTable";
import ModalBoxEdit from "./ModalboxEdit";
import ModalBoxDelete from "./ModalboxDelete";
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";

class ExpandableRowEntry extends React.Component {
    rows;
    constructor(props) {
        super(props);
        this.state={childRows:[], childRowId:0, musteriID:"", locationDelete:false, locationsChanged:false};
        this.getDatas();
}


 async getDatas() {
     console.log('props',this.props.rowData);
     const customerID = this.props.rowData[0];
     const row = await api.get('/lookups/lokasyonlar', {
         params: {
             musteri_id: customerID
         }
     } );

     //console.log(JSON.parse(JSON.stringify(row.data.data)));
    this.rows=Array.isArray(row.data) ? row.data : (row.data?.data || []);
     this.setState({musteriID:this.rows[0].musteri_id})

     const locations = this.rows.map(d => ({
         "id":d.id,
         "lokasyon_id":d.lokasyon_id ,
         "ulke" : d.ulke,
         "sehir": d.sehir ,
         "yetkili": d.yetkili,
         "telefon":d.telefon,
         "eposta":d.eposta,
         "yetkili_iki": d.yetkili_iki,
         "yetkili_iki_telefon":d.yetkili_iki_telefon,
         "yetkili_iki_eposta":d.yetkili_iki_eposta,
         "yetkili_uc": d.yetkili_uc,
         "yetkili_uc_telefon":d.yetkili_uc_telefon,
         "yetkili_uc_eposta":d.yetkili_uc_eposta,
         "yetkili_dort": d.yetkili_dort,
         "yetkili_dort_telefon":d.yetkili_dort_telefon,
         "yetkili_dort_eposta":d.yetkili_dort_eposta,
         "yetkili_bes":d.yetkili_bes,
         "telefon_bes":d.yetkili_bes_telefon,
         "eposta_bes":d.yetkili_bes_eposta,
         "yetkili_alti":d.yetkili_alti,
         "telefon_alti":d.yetkili_alti_telefon,
         "eposta_alti":d.yetkili_alti_eposta,
         "yetkili_yedi":d.yetkili_yedi,
         "telefon_yedi":d.yetkili_yedi_telefon,
         "eposta_yedi":d.yetkili_yedi_eposta,
         "yetkili_sekiz":d.yetkili_sekiz,
         "telefon_sekiz":d.yetkili_sekiz_telefon,
         "eposta_sekiz":d.yetkili_sekiz_eposta,
         "yetkili_dokuz":d.yetkili_dokuz,
         "telefon_dokuz":d.yetkili_dokuz_telefon,
         "eposta_dokuz":d.yetkili_dokuz_eposta,
         "adres": d.adres,
         "lokasyon_adi" : d.lokasyon_adi,
         "musteri_id" : d.musteri_id,

     }))
     //console.log(products);
     this.setState({childRows: locations})



 }
    locationChange = (data) => {
        if(data) {
            this.getDatas();

        }
    }

    render() {
        const data =  this.state.childRows;
        let datas=[];
        const options = {
            filter: false,
            onFilterChange: (changedColumn, filterList) => {
                console.log(changedColumn, filterList);
            },
            selectableRows: false,
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: 100,
            fixedHeader: true,
            //fixedSelectColumn: true,
            tableBodyHeight: '100%',
            print:false,
            download:true,
            draggableColumns: {
                enabled:true,
                transitionTime:400
            },
            rowStyle: {
                fontSize: 9,
            },
            downloadOptions: {
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },
            onRowSelectionChange : (curRowSelected, allRowsSelected) => {
                datas.length=0;
                console.log("---RowSelect")
                console.log("Row Selected: ", curRowSelected);
                console.log("All Selected: ", allRowsSelected);

                if(allRowsSelected) {
                    allRowsSelected.forEach((result)=>{
                        datas.push(this.state.childRows[result.dataIndex]);
                    })
                }
            },
            textLabels :{
                selectedRows: {
                    text: "satır seçildi",
                    delete: "SiparişeEkle",
                    deleteAria: "Seçilenleri siparişe aktar",
                },
                pagination: {
                    next: "İleri",
                    previous: "Geri",
                    rowsPerPage: "Sayfadaki satır sayısı:",
                    displayRows: "/",
                },
                toolbar: {
                    search: "Ara",
                    downloadCsv: "XLSX İndir",
                    print: "Çıktı Al",
                    viewColumns: "Sütunları Göster",
                    filterTable: "Tabloyu Süz",
                },
                filter: {
                    all: "Tümünü Göster",
                    title: "Filtreler",
                    reset: "Sıfırla",
                },
                viewColumns: {
                    title: "Sütunları Göster",
                    titleAria: "Sütunları Göster/Gizle",
                },

            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const fileExtension = ".xlsx";

                console.log(values.forEach(val => console.log(val)));

                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => {
                        temp[columns[idx].name] = v;
                    });
                    result.push(temp);
                    return result;
                }, []);

                const fileName = `Müşteri Listesi`;
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName + fileExtension);
                // cancel default  CSV download from table
                return false;
            },
            expandableRows: true,

            renderExpandableRow: (rowData, rowMeta) => {

                return ( <ExpandableRowMachinesTable rowData={rowData} rowMeta={rowMeta} />   );
            },
        };
        const myTheme  =createTheme(adaptV4Theme({
            overrides: {
                MUIDataTableHead:{
                    root:{
                        lineHeight:0.5,
                        maxHeight:"10px",
                        padding:0
                    }
                },
                MUIDataTableBodyRow: {
                    root: {
                        '&:nth-child(odd)': {
                            backgroundColor: '#e8e8e8'
                        },
                        lineHeight:'0.2!important'
                    }
                },
                MUIDataTableBodyCell: {
                    root: {

                        lineHeight:0.1
                    }
                },
                MuiButtonBase: {
                    root: {
                        padding:'2px 2px !important',

                    }
                },
                MUIDataTableToolbar:{
                  root:{
                      display: "none"
                  }
                },
                MUIDataTableFooter:{
                    root:{
                        display: "none"
                    }
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: "#e59e53 !important",
                        fontWeight: "bold",
                        padding:1,
                        lineHeight:0.1
                    },

                root: {
                    lineHeight:0.5
                }
                },

            },
        }));
        const columns = [
            {
                name: "lokasyon_id",
                label:"Lokasyon ID",
                options: {
                    filter:false,
                    sort:false,
                }
            },
            {
                name: "lokasyon_adi",
                label:"Lokasyon Adı",
                options: {
                    filter:false,
                    sort:false,
                }
            },


            {
                name: "ulke",
                label: "Ülke",
                options: {
                    filter: true,
                    filterOptions: {
                        fullWidth: true
                    },

                },
            },
            {
                name: "sehir",
                label: "Şehir",
                options: {
                    filter: true,
                    filterOptions: {
                        fullWidth: true
                    }
                },
            },

            {
                name: "yetkili",
                label: "Yetkili",
                options: {
                    filter: false,

                }
            },
            {
                name: "lokasyon_id",
                label: "Duzenle",
                options: {
                    filter: false,
                    customBodyRender: (value, meta, updateValue) => {
                        const record = data[meta.currentTableData[meta.rowIndex].index];
                        return (
                            <ModalBoxEdit
                               values={record} locationChange={this.locationChange}

                            />
                        );
                    },
                }
            },
            {
                name: "id",
                label: "Sil",
                options: {
                    filter: false,
                    customBodyRender: (value, meta, updateValue) => {
                        const record = data[meta.currentTableData[meta.rowIndex].index];
                        return (
                            <ModalBoxDelete
                                id={record.id} locationChange={this.locationChange}
                            />
                        );
                    },
                }
            },

        ];

return(<React.Fragment>

    <ModalBox
        addDataSource={(dname, dsource) => this.addDataSource(dname, dsource)} musteriID={this.props.rowData[0]} locationChange={this.locationChange}
    />
    <tr>
        <td colSpan={9}>
            <ThemeProvider theme={myTheme}>
                <MUIDataTable title={"Lokasyonlar"} data={this.state.childRows} columns={enhanceColumns(columns)} options={withTableOptions(options)} />
            </ThemeProvider>
        </td>
    </tr>

</React.Fragment> )

    };

};

export default ExpandableRowEntry;
